// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"3b260bed","212":"2250649c","281":"56df059f","291":"135db23e","533":"c9f99784","725":"ff8c137b","838":"82f8e800","891":"8c3529dc"}[chunkId] + ".chunk.css";
};